import { FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStackItem, FormStack } from 'forms/FormStack'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
// import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export class ProvingDetailsMaterialsFormSchema {
  constructor() {
    return Yup.object().shape({
      comment: Yup.string(),
    })
  }
}

export const ProvingDetailsMaterialsAnnotationForm: React.FC<{}> = () => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStackItem
        name={'annotation'}
        render={(fieldProps) => (
          <FormikTextField
            label={t('field.material.annotation')}
            {...fieldProps}
            required={false}
          />
        )}
      />
    </FormStack>
  )
}
